import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../redux/actions';
import { printRupee, handleApiExceptions, goTo, alertify } from '../../app_methods';
import { Text2, Text4, RoundedCard } from '../../styles';
import { TransferRequest } from '../../models';
import { InfoCard } from './styles';
import { DatePicker, Spin, Button, Tooltip, Icon, Card, Modal } from 'antd';
import { LineChart, DonutChart } from '../Common';
import { chartStatusTypes, generateTransfersChartDataSet, generatePaymentModeDataSet, generatePaymentSourceDataSet } from './constants';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import './index.scss';
import { EaseCurrency } from '../../libs/EaseCurrency';
import { PermissionHoc } from '../HOC';
import { BannerModal } from './banner_modal';


const moment = extendMoment(Moment);

const PermissableButton = PermissionHoc(Button, "TRANSFERS_EXPORT", { is_component: true, fallbackComponent: null })

const Dashboard = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [insightsData, setInsightsData] = useState({});
    const [isBannerModal, setIsBannerModal] = useState(false);
    const [adImageCurrentIndex, setAdImageCurrentIndex] = useState(0);
    const [bannerData, setBannerData] = useState({});
    const [adImageOpacity, setAdImageOpacity] = useState(true);
    const [filters, setFilters] = useState({
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD")
    });

    const fetchInsights = async (_filters) => {
        if (!props.current_user.key) return;
        setIsLoading(true);
        const response = await TransferRequest.get_insights({ ..._filters });
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setInsightsData(response.data);
        setIsLoading(false);
    };

    const downloadReport = async () => {
        setIsLoading(true);
        if (filters.start_date && filters.end_date) {
            if (moment(filters.end_date).diff(moment(filters.start_date), "days") > 31) {
                handleApiExceptions("This report can be downloaded for only 31 days or less.");
                setIsLoading(false);
                return;
            }

        }
        const response = await TransferRequest.download_report({ created_at_start: filters.start_date, created_at_end: filters.end_date });
        if (!response) {
            setIsLoading(false);
            handleApiExceptions("Something went wrong !");
            return;
        }
        alertify(
            "Success",
            response?.data?.message || "Request generated Successfully",
            "confirm",
            {
                closable: true,
                cancelText: "Close",
                okText: "Go to Report Section",
                onOk: () => goTo(`/reports`, props.history),
                onCancel: () => { },
                icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            }
        );
        setIsLoading(false);
    };

    const getTotalData = (status) => {
        const statusData = insightsData.totals && insightsData.totals.find(total => total.status == status);
        return statusData ? parseFloat(statusData.total.toFixed(2)) : 0.00;
    };

    const getCummulativeTotal = () => {
        return parseFloat((getTotalData("accepted") + getTotalData("in_process") + getTotalData("success") + getTotalData("failure")).toFixed(2));
    }

    const getTotalPercentage = (status) => {
        const cummulativeTotal = getCummulativeTotal();
        return cummulativeTotal == 0.00 ? 0.00 : ((getTotalData(status) / cummulativeTotal) * 100).toFixed(2);
    }

    const handleFiltersChange = (values) => {
        const _filters = filters;
        _filters.start_date = values[0].format("YYYY-MM-DD");
        _filters.end_date = values[1].format("YYYY-MM-DD");
        setFilters(_filters);
        fetchInsights(_filters);
    }
    const updateIndex = (newAdImageIndex) => {
        setAdImageOpacity(false);
    
        setTimeout(() => {
            setAdImageOpacity(true);
            setAdImageCurrentIndex((prevIndex) => (prevIndex + 1) % props.current_user?.ad_banner.length);
            const nextIndex = (newAdImageIndex + 1) % props.current_user?.ad_banner.length;
            setTimeout(() => updateIndex(nextIndex), props.current_user?.ad_banner[nextIndex]?.visible_time * 1000);
        }, 300);
    };
    useEffect(() => {
        props.onChildMount();
        fetchInsights(filters);
        if (Array.isArray(props.current_user?.ad_banner) && props.current_user?.ad_banner?.length!=0) {
            setTimeout(()=>updateIndex(0), props.current_user?.ad_banner[0]?.visible_time*1000);
        }
    }, []);

    const renderFilters = () => {
        return (
            <DatePicker.RangePicker
                className="mr-1"
                disabledDate={(date) => date.valueOf() > moment().valueOf() || date.valueOf() < moment().subtract(32, 'days')} // Future dates and dates before 31 days are disabled.
                allowClear={false}
                defaultValue={[moment(), moment()]}
                ranges={{
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
                    'This Week': [moment().startOf('week'), moment()],
                    'This Month': [moment().startOf('month'), moment()],
                    'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                    'Last 31 Days': [moment().subtract(31, 'days'), moment()]
                }}
                style={{ width: "222px" }}
                format="YYYY-MM-DD"
                placeholder="Date Range Filter"
                onChange={handleFiltersChange}
            />
        )
    };

    const renderDownloadReportButton = () => {
        return (
            <Tooltip title="Download Report" placement="bottomLeft">
                {props.current_user.allow_dashboard_download ?
                    <PermissableButton
                        icon="download"
                        onClick={downloadReport}
                        disabled={!insightsData.date_wise_status_report || !insightsData.date_wise_status_report.length}
                    />
                    : null}
            </Tooltip>
        )
    };

    const renderInfoCards = () => {
        return (
            <div className="mb-4 w-100 d-flex justify-content-between">
                <InfoCard style={{ borderTop: "3px solid rgb(54, 162, 235)" }}>
                    <Text4 className="d-block mb-1" type="secondary">Transfers Initiated</Text4>
                    <EaseCurrency amount={getCummulativeTotal()} size="l" prefix="₹" suffix="/-" />
                    {/* <Statistic title="Transfers Initiated" value={getCummulativeTotal().toLocaleString("en-IN", { minimumFractionDigits: 2 })} prefix="₹" suffix="/-" /> */}
                </InfoCard>
                <InfoCard style={{ borderTop: "3px solid rgb(255, 193, 7)" }}>
                    <Text4 className="d-block mb-1" type="secondary">Transfers In-Process</Text4>
                    <EaseCurrency amount={getTotalData("in_process")} size="l" prefix="₹" suffix="/-" />
                    {/* <Statistic title="Transfers In-Process" value={getTotalData("in_process").toLocaleString("en-IN", { minimumFractionDigits: 2 })} prefix="₹" suffix="/-" /> */}
                </InfoCard>
                <InfoCard style={{ borderTop: "3px solid rgb(40, 167, 69)" }}>
                    <Text4 className="d-block mb-1" type="secondary">Transfers Processed</Text4>
                    <EaseCurrency amount={getTotalData("success")} size="l" prefix="₹" suffix={`/- (${getTotalPercentage("success")}%)`} />
                    {/* <Statistic title="Transfers Processed" value={getTotalData("success").toLocaleString("en-IN", { minimumFractionDigits: 2 })} prefix="₹" suffix={`/- (${getTotalPercentage("success")}%)`} /> */}
                </InfoCard>
                <InfoCard style={{ borderTop: "3px solid rgb(220, 23, 69)" }}>
                    <Text4 className="d-block mb-1" type="secondary">Transfers Failed</Text4>
                    <EaseCurrency amount={getTotalData("failure")} size="l" prefix="₹" suffix={`/- (${getTotalPercentage("failure")}%)`} />
                    {/* <Statistic title="Transfers Failed" value={getTotalData("failure").toLocaleString("en-IN", { minimumFractionDigits: 2 })} prefix="₹" suffix={`/- (${getTotalPercentage("failure")}%)`} /> */}
                </InfoCard>
            </div>
        )
    };

    const generateDatasets = (data, chartLabels) => {
        let chartDatasets = [];
        chartStatusTypes.forEach(x => chartDatasets.push(generateTransfersChartDataSet(
            x.label,
            x.lineColor,
            chartLabels.map(a => {
                let status = data.filter(b => b.status == x.key).find(c => moment(c.date_time).format(filters.start_date == filters.end_date ? "LT" : "MMM DD") == a);
                return (status && status.total) || 0;
            })
        )));
        return chartDatasets;
    };

    const renderTransfersChart = () => {
        let data = (insightsData && insightsData.date_wise_status_report) || [];
        data && data.sort((a, b) => a.date_time - b.date_time);
        let chartLabels = data.map(a => moment(a.date_time));
        if (filters.start_date == filters.end_date) {
            chartLabels = Array.from(moment.range(moment(filters.start_date).startOf("day"), moment(filters.end_date).endOf("day")).by("hours"));
            chartLabels = chartLabels.map(a => a.format("LT"));
        }
        else {
            chartLabels = Array.from(moment.range(moment(filters.start_date), moment(filters.end_date)).by("days"));
            chartLabels = chartLabels.map(a => a.format("MMM DD"));
        }
        const chartDatasets = generateDatasets(data, chartLabels);
        return (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <RoundedCard className="mb-4">
                        <Text2 className="mb-4 d-block" strong>Success vs Failure</Text2>
                        <LineChart
                            width={500}
                            height={150}
                            labels={chartLabels}
                            datasets={chartDatasets}
                            xAxesOptions={{
                                render: (value) => `₹ ${value}/-`
                            }}
                        />
                    </RoundedCard>
                </div>
            </div>
        )
    };

    const renderPaymentModesChart = () => {
        let chartLabels = ["NEFT", "RTGS", "IMPS", "UPI"];
        let data = (insightsData && insightsData.payment_mode_report) || [];
        let dataSetParams = {};
        chartLabels.forEach(x => {
            let type = data.find(a => a.payment_mode == x);
            return dataSetParams[x] = (type && type.total) || 0;
        });
        let chartDatasets = [generatePaymentModeDataSet(dataSetParams)];
        return (
            <div className="col-sm-12 col-md-6 col-lg-6">
                <RoundedCard>
                    <Text2 className="mb-4 d-block" strong>Mode Distribution</Text2>
                    <DonutChart
                        width={350}
                        height={150}
                        labels={chartLabels}
                        datasets={chartDatasets}
                    />
                </RoundedCard>
            </div>
        )
    };

    const renderPaymentSourceChart = () => {
        let chartLabels = ["Dashboard", "API"];
        let data = (insightsData && insightsData.payment_source_report) || [];
        let dataSetParams = {};
        ["dashboard", "api"].forEach(x => {
            let type = data.find(a => a.transfer_request_source == x);
            return dataSetParams[x] = (type && type.total) || 0;
        });
        let chartDatasets = [generatePaymentSourceDataSet(dataSetParams)];
        return (
            <div className="col-sm-12 col-md-6 col-lg-6">
                <RoundedCard>
                    <Text2 className="mb-4 d-block" strong>Source Distribution</Text2>
                    <DonutChart
                        width={350}
                        height={150}
                        labels={chartLabels}
                        datasets={chartDatasets}
                    />
                </RoundedCard>
            </div>
        )
    }

    const toggleBannerModal = () =>{
        setIsBannerModal(!isBannerModal);
        if (props.current_user?.ad_banner[adImageCurrentIndex]?.on_click_settings?.type=='REDIRECT') {
            setIsBannerModal(false);
            if(props.current_user?.ad_banner[adImageCurrentIndex]?.on_click_settings?.target=='_blank') {
                window.open(props.current_user?.ad_banner[adImageCurrentIndex]?.on_click_settings?.redirect_url);
            } else {
                window.location.href = props.current_user?.ad_banner[adImageCurrentIndex]?.on_click_settings?.redirect_url;
            }
        }
        setBannerData(props.current_user?.ad_banner[adImageCurrentIndex]);
    }

    const renderADbanner = ()=>{
        return (
          <div
            onClick={toggleBannerModal}
            style={{
              marginBottom: "22px",
              borderRadius: "4px",
              cursor: "pointer",
              display: "flex",
              width: "100%",
              maxHeight: 88,
            }}
          >
            {props.current_user?.show_ad &&
            Array.isArray(props.current_user?.ad_banner) &&
            props.current_user?.ad_banner?.length != 0 ? (
              <img
                src={props.current_user?.ad_banner[adImageCurrentIndex]?.banner_image}
                alt="There should be an image here"
                className={adImageOpacity ? "show" : "hide"}
                style={{ borderRadius: "4px", width: "100%" }}
              />
            ) : null}
          </div>
        );
    }

    return (
        <Spin spinning={isLoading} >
            <div className="mb-4 dashboard-wrapper">
                {renderADbanner()}
                <div className="mb-3 d-flex justify-content-end">
                    {renderFilters()}
                    {renderDownloadReportButton()}
                </div>
                {renderInfoCards()}
                {renderTransfersChart()}
                <div className="row">
                    {renderPaymentModesChart()}
                    {renderPaymentSourceChart()}
                </div>
            </div>
            <BannerModal
            visible={isBannerModal}
            toggleBannerModal={toggleBannerModal}
            data={bannerData}
            destroyOnClose={true}
            >
            </BannerModal>
        </Spin>
    );
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(Dashboard, 'DASHBOARD_READ'));